<template>
    <v-container fluid>
        <!-- <Overlay/> -->
        <v-row align="center" justify="center" v-if="permissable">
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <h1 class="platformName">{{ stepName }}</h1>
                <p class="platformSubtitle">{{ sectionName }}</p>
            </v-col>
        </v-row>
        <v-row align="center" justify="center" v-else>
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <v-card>
                    <v-card-title><h1>Premium Content</h1></v-card-title>
                    <v-card-text>

                        <p>You've reached a premium page. If you'd like access to this page and additional premium features, contact support@swyftsites.com.</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row align="start"
               justify="center"
               v-if="permissable"
        >
            <v-col cols="12"
                   sm="10" lg="9" xl="7"
                   v-if="sectionCards"
            >
                <Card v-for="(card, id) in sectionCards"
                      :id="card.id"
                      :key="card.name+card.id+id"
                      class="mb-10"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

// import Overlay from '../../components/Overlay';
import { mapState, mapActions } from 'vuex';
import Card from './Card/Card';

export default {
    components: { Card, /* Overlay */ },

    computed: {
        ...mapState('site',
            [
                'sectionName',
                'sectionSubtitle',
                'sectionCards',
                'sectionData',
                'stepName',
                'permissable'
            ]
        )
    },

    watch: {
        '$route.path'() {
            this.getSectionData();
        }
    },

    data() {
        return {
            panel: [0,1,2,3,4,5,6,7,8,9,10],
        };
    },

    mounted() {
        this.getSectionData();
    },

    methods: {
        ...mapActions({
            getSectionData: 'site/getSectionData'
        })
    }
};
</script>
<style lang="scss">
    .platformName {
        flex: 0 0 100%;
        width: 100%;
        margin-top: 60px;
        font-size: 3.3rem;
        text-align: center;
    }

    .platformSubtitle {
        flex: 0 0 100%;
        width: 100%;
        text-align: center;
        color: $primary-500;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 5px;
    }
</style>
